module.exports = __webpack_public_path__ + "img/whatsapp-1.ad7d72fe.webp";